import {
    Button,
    ButtonProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    styled,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const CancelButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: "#0093D1",
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "none",
    padding: "6px 16px",
}));

const ConfirmButton = styled(Button)<ButtonProps>(({ theme }) => ({
    fontSize: "16px",
    fontWeight: 500,
    color: "white",
    backgroundColor: "#0093D1",
    borderColor: "#0093D1",
    borderRadius: "4px",
    boxShadow: "none",
    textTransform: "none",
    padding: "6px 16px",
    "&:hover": {
        backgroundColor: "#0093D1",
        borderColor: "#0093D1",
        boxShadow: "none",
    },
    "&:active": {
        boxShadow: "none",
        backgroundColor: "#0093D1",
        borderColor: "#0093D1",
    },
}));

const ConfirmDialogContentText = styled(DialogContentText)(() => ({
    color: "#333333",
    fontSize: "18px",
    fontWeight: 300,
    lineHeight: "26px",
}));

const ConfirmDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
        width: "343px",
        [theme.breakpoints.up("lg")]: {
            width: "432px",
        },
    },
}));

const ConfirmationDialog = (props: {
    open: boolean;
    title: string;
    message: string;
    confirmButtonLabel: string;
    cancelButtonLabel: string;
    cancelAction: () => void;
    confirmAction: () => void;
}) => {
    const { open, confirmAction, cancelAction, title, message, cancelButtonLabel, confirmButtonLabel } = props;

    const { t } = useTranslation();

    return (
        <ConfirmDialog onClose={cancelAction} open={open} data-cy={"conformation-dialog"}>
            <DialogTitle sx={{ paddingTop: "24px", paddingBottom: "24px" }}>{t(title)}</DialogTitle>
            <DialogContent sx={{ padding: "0px 24px" }}>
                <ConfirmDialogContentText>{t(message)}</ConfirmDialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: "24px" }}>
                <CancelButton onClick={cancelAction} data-cy={"dialog-cancel-button"}>
                    {t(cancelButtonLabel)}
                </CancelButton>
                <ConfirmButton onClick={confirmAction} data-cy={"dialog-confirm-button"}>
                    {t(confirmButtonLabel)}
                </ConfirmButton>
            </DialogActions>
        </ConfirmDialog>
    );
};
export default ConfirmationDialog;
